export default __webpack_public_path__ + "static/media/icon-web-hosting-round.17913292.svg";